import { takeEvery, call, put } from 'redux-saga/effects';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../../shared/api/headers';
import { DO_STANDARD_LOGIN_URL, DEFAULT_BASE_URL, GET_APPETIZE_PREF_URL } from '../../../shared/api/urls';
import { apiPost, apiRequest } from '../../../shared/api';
import { DO_STANDARD_LOGIN } from '../../../actions/actionTypes';
import { setStandardLoginErrors } from '../../../actions/actionCreators';
import { POST } from '../../../shared/api/httpMethods';
import { getAppetizePreferenceAction, setAppetizePreferenceAction } from '../../../slices';

function* doStandardLoginAsync(action) {
    const { credentials } = action;
    const standardLoginPayload = {
        UserType: 'MVEntityUser',
        UserID: credentials.username,
        Password: credentials.password,
        Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const postConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        method: POST,
        baseURL: DEFAULT_BASE_URL,
        url: DO_STANDARD_LOGIN_URL,
    };
    try {
        const { data: { redirectUrl } } = yield call(apiPost, standardLoginPayload, postConfig);
        if (redirectUrl) {
            window.location.replace(redirectUrl);
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        yield put(setStandardLoginErrors(error));
    }
}

function* getAppetizePreference() {
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: GET_APPETIZE_PREF_URL,
    };
    try {
        const { data } = yield call(apiRequest, requestConfig);
        yield put(setAppetizePreferenceAction(data));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Login Saga error:', error);
    }
}

export default function* watchDoStandardLogin() {
    yield takeEvery(DO_STANDARD_LOGIN, doStandardLoginAsync);
    yield takeEvery(getAppetizePreferenceAction, getAppetizePreference);
}
